import {gql} from "@apollo/client";

export const UpdateLastHostedAdventure = gql`
    mutation updateLastHostedAdventure($userId: Int!, $adventureId: Int!) {
        updateLastHostedAdventure(userId: $userId, adventureId: $adventureId)
    }
`

export const UpdateLastPlayedAdventure = gql`
    mutation updateLastPlayedAdventure($userId: Int!, $adventureId: Int!) {
        updateLastPlayedAdventure(userId: $userId, adventureId: $adventureId)
    }
`